module.exports = __webpack_public_path__ + "static/media/btn_01.c3a8080e.png";